import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const input = "w-full rounded-sm border border-stone-300 bg-white px-4 py-3 text-sm font-sans focus:outline-none focus:ring-2 focus:ring-bronze-dark/40 focus:border-bronze-dark";
  return (
    <div data-testid="forgot-page" className="container-ccc py-16 max-w-md">
      <div className="eyebrow">Password reset</div>
      <h1 className="font-serif text-4xl mt-3">Reset your password.</h1>
      {done ? (
        <p className="mt-6 text-ink-muted">If an account exists for that email, a reset link has been generated. Check your inbox for instructions.</p>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form" className="mt-10 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-ink-muted mb-2">Email</label>
            <input required type="email" data-testid="forgot-email-input" className={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          {error && <div className="text-sm text-destructive">{error}</div>}
          <button disabled={loading} type="submit" data-testid="forgot-submit-button" className="btn-primary w-full">{loading ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <div className="mt-6 text-sm">
        <Link to="/login" className="text-bronze-dark">← Back to sign in</Link>
      </div>
    </div>
  );
}
